module.exports = __webpack_public_path__ + "img/unp.4054779b.svg";